/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Slovak
export default {
  'automation-menu.empty-state.image.alt': 'Ikona prázdneho zoznamu automatizácie',
  'automation-menu.empty-state.learn-more.link': 'Ďalšie informácie o ručnom spúšťači',
  'automation-menu.modal.empty.automations.admin.description':
    'Pomocou ručného spúšťača môžete vyplniť ponuku výberov, ktoré môže ktokoľvek alebo vami určené osoby jedným kliknutím použiť ako automatizácie.',
  'automation-menu.modal.empty.automations.user.description':
    'Správcovia zatiaľ nenakonfigurovali žiadne ručne spúšťané automatizácie.',
  'automation-menu.modal.error.description': 'Načítavanie trvá príliš dlho. Skúste obnoviť stránku.',
  'automation-menu.modal.error.image.alt': 'Ikona chyby',
  'automation-menu.modal.footer.automate-button': 'Zautomatizovať',
  'automation-menu.modal.footer.cancel-button': 'Zrušiť',
  'automation-menu.modal.footer.get-started-button': 'Vytvoriť automatizáciu',
  'automation-menu.modal.footer.ok-button': 'Ok',
  'automation-menu.modal.header.icon.label': 'Ikona hlavičky modálneho okna automatizácie',
  'automation-menu.success-state.message': 'Prebieha automatizácia',
  'fabric.linking.access_exists_description': 'Požiadajte o prístup k zobrazeniu tohto obsahu z lokality {hostname}.',
  'fabric.linking.actions': 'Činnosti',
  'fabric.linking.add_account': 'Pridať konto',
  'fabric.linking.ai_summarize': 'Zhrnúť',
  'fabric.linking.ai_summarized': 'Zhrnuté nástrojom Atlassian Intelligence',
  'fabric.linking.ai_summarized_abbreviation': 'Zhrnuté nástrojom AI',
  'fabric.linking.ai_summarized_info': 'Kvalita informácií sa môže meniť. <a>Ďalšie informácie</a>',
  'fabric.linking.ai_summarized_info_short': 'Kvalita obsahu sa môže meniť',
  'fabric.linking.ai_summarizing': 'Nástroj Atlassian Intelligence pracuje...',
  'fabric.linking.ai_summary_action': 'Zhrnúť pomocou AI',
  'fabric.linking.ai_summary_action_description':
    'Vytvorte súhrn obsahu tohto prepojenia pomocou nástroja Atlassian Intelligence.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    'Výsledky tohto súhrnu nie je možné zobraziť, pretože sú v rozpore so <a>Zásadami prijateľného používania spoločnosti Atlassian</a>.',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'Atlassian Intelligence momentálne nedokáže vygenerovať súhrn, pretože množstvo obsahu na zhrnutie je príliš veľké.',
  'fabric.linking.ai_summary_error_generic':
    'Nástroj Atlassian Intelligence (AI) neodpovedá. Skúste to znova neskôr alebo <a>skontrolujte stav nástroja AI</a>.',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'Nástroj Atlassian Intelligence nemohol spracovať vašu požiadavku, pretože v obsahu sú prepojenia na obsah s obmedzeným prístupom podľa zákona HIPAA.',
  'fabric.linking.assigned_to': 'Pridelené k položke {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    'Použite automatizáciu na položku <b>{name}</b>.{br}Dostupné výbery sú určené správcami aplikácie Confluence a priestorov.',
  'fabric.linking.automation-action.confluence.page.modal.title': 'Automatizácie stránok',
  'fabric.linking.automation-action.icon.label': 'Ikona automatizácie',
  'fabric.linking.automation-action.title': 'Zobraziť pravidlá automatizácie',
  'fabric.linking.automation-action.tooltip': 'Vyberte pravidlo automatizácie, ktoré chcete spustiť.',
  'fabric.linking.beta': 'Beta',
  'fabric.linking.cancel': 'Zrušiť',
  'fabric.linking.cannot_connect': 'Nedá sa pripojiť, skúste to znova',
  'fabric.linking.cannot_find_link': 'Prepojenie sa nenašlo',
  'fabric.linking.check_this_link': 'Vyskúšajte toto prepojenie',
  'fabric.linking.click_to_join': 'Pripojiť sa k službe {context}',
  'fabric.linking.click_to_join_description':
    'Vaša požiadavka bola schválená, takže sa môžete hneď pripojiť k aplikácii {context}.',
  'fabric.linking.close': 'Zatvoriť',
  'fabric.linking.connect_account_description':
    'Otvoríme novú stránku, aby sme vám pomohli s pripojením k vášmu kontu {name}',
  'fabric.linking.connect_link_account': 'Ak chcete zobraziť ukážku, pripojte sa',
  'fabric.linking.connect_link_account_card_view': 'Pripojiť',
  'fabric.linking.connect_link_account_card_view_description':
    'Ak chcete zobraziť ukážku tohto prepojenia, pripojte svoje konto {context}.',
  'fabric.linking.connect_link_account_card_view_name': 'Pripojte svoje konto {context}',
  'fabric.linking.connect_to': 'Pripojiť k službe {name}',
  'fabric.linking.connect_unauthorised_account_action': 'Pripojiť k {context}',
  'fabric.linking.connect_unauthorised_account_description':
    'Pripojte svoje konto {context}, aby ste mohli spolupracovať v rámci produktov Atlassian.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Pripojte svoje konto, aby ste mohli spolupracovať v rámci produktov Atlassian.',
  'fabric.linking.continue': 'Pokračovať',
  'fabric.linking.copied_summary_action_description': 'Súhrn bol skopírovaný do schránky.',
  'fabric.linking.copied_url_to_clipboard': 'Skopírované!',
  'fabric.linking.copy_summary_action': 'Kopírovať súhrn',
  'fabric.linking.copy_summary_action_description': 'Kopírovať súhrn',
  'fabric.linking.copy_url_to_clipboard': 'Kopírovať prepojenie',
  'fabric.linking.couldnt_load_link': 'Toto prepojenie sa z neznámeho dôvodu nepodarilo načítať.',
  'fabric.linking.create_on_absolute': 'Vytvorené: {context}',
  'fabric.linking.create_on_relative': 'Vytvorené: {context}',
  'fabric.linking.created_by': 'Vytvoril(a): {context}',
  'fabric.linking.delete': 'Odstrániť',
  'fabric.linking.direct_access': 'Pripojiť sa',
  'fabric.linking.direct_access_description':
    'Váš tím používa produkt {product} na spoluprácu a vy ho môžete začať ihneď používať.',
  'fabric.linking.direct_access_title': 'Ak chcete zobraziť tento obsah, pripojte sa k produktu {product}.',
  'fabric.linking.download': 'Stiahnuť',
  'fabric.linking.download_description': 'Stiahnuť tento súbor do lokálneho úložiska',
  'fabric.linking.download_file': 'Stiahnuť súbor',
  'fabric.linking.edit': 'Upraviť',
  'fabric.linking.follow': 'Sledovať',
  'fabric.linking.follow_goal': 'Sledovať cieľ',
  'fabric.linking.follow_goal_description': 'Ak chcete dostávať aktuálne informácie o tomto cieli, sledujte ho.',
  'fabric.linking.follow_goal_error':
    'Vyskytla sa chyba pri pokuse aktivovať sledovanie cieľa. Skontrolujte pripojenie alebo obnovte stránku a skúste to znova.',
  'fabric.linking.follow_project': 'Sledovať projekt',
  'fabric.linking.follow_project_description':
    'Ak chcete dostávať upozornenia týkajúce sa tohto projektu, začnite ho sledovať.',
  'fabric.linking.follow_project_error':
    'Vyskytla sa chyba pri pokuse aktivovať sledovanie projektu. Skontrolujte pripojenie alebo obnovte stránku a skúste to znova.',
  'fabric.linking.forbidden_access': 'Máte zakázaný prístup',
  'fabric.linking.forbidden_description': 'Obráťte sa na správcu a požiadajte o prístup na lokalitu {hostname}.',
  'fabric.linking.forbidden_title': 'K tomuto obsahu nemáte prístup.',
  'fabric.linking.generic_error_message': 'Vyskytla sa chyba',
  'fabric.linking.go_back': 'Vrátiť sa',
  'fabric.linking.invalid_permissions': 'Obsah s obmedzeným prístupom',
  'fabric.linking.invalid_permissions_description':
    'Ak chcete zobraziť túto ukážku, požiadajte o prístup alebo vyskúšajte iné konto.',
  'fabric.linking.join_to_view': 'Ak chcete zobraziť tento problém, pripojte sa k aplikácii {context}',
  'fabric.linking.join_to_view-issue-term-refresh':
    'Ak chcete zobraziť túto pracovnú položku, pripojte sa k aplikácii {context}.',
  'fabric.linking.learn_more_about_connecting_account': 'Zistite viac o pripojení svojho konta k produktom Atlassian.',
  'fabric.linking.learn_more_about_smart_links': 'Ďalšie informácie o inteligentných prepojeniach',
  'fabric.linking.link_safety_warning_message':
    'Prepojenie {unsafeLinkText} vás presmeruje na inú lokalitu, <a>sem vložte aktuálne prepojenie</a>',
  'fabric.linking.loading': 'Načítava sa...',
  'fabric.linking.modified_on_absolute': 'Aktualizované: {context}',
  'fabric.linking.modified_on_relative': 'Aktualizované: {context}',
  'fabric.linking.more_actions': 'Ďalšie činnosti',
  'fabric.linking.more_information_about_this_work_item': 'Viac informácií o tejto pracovnej položke',
  'fabric.linking.no_access_title': 'Ak chcete zobraziť tento obsah, pripojte sa k produktu {product}.',
  'fabric.linking.not_found_description': 'Stránka neexistuje alebo sa mohla zmeniť po pridaní tohto prepojenia.',
  'fabric.linking.not_found_title': 'Táto stránka produktu {product} sa nedá zobraziť.',
  'fabric.linking.open_issue_in_jira': 'Otvoriť problém v aplikácii Jira',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Otvoriť pracovnú položku v aplikácii Jira',
  'fabric.linking.open_link_in_a_new_tab': 'Otvoriť prepojenie na novej karte',
  'fabric.linking.owned_by': 'Patrí používateľovi {context}',
  'fabric.linking.pending_request': 'Vaša požiadavka na udelenie prístupu čaká na vybavenie',
  'fabric.linking.preview_close': 'Zavrieť ukážku',
  'fabric.linking.preview_description': 'Otvoriť ukážku tohto prepojenia na celej obrazovke',
  'fabric.linking.preview_improved': 'Otvoriť ukážku',
  'fabric.linking.preview_max_size': 'Zobraziť na celej obrazovke',
  'fabric.linking.preview_min_size': 'Zavrieť celú obrazovku',
  'fabric.linking.priority_blocker': 'Blokujúci problém',
  'fabric.linking.priority_critical': 'Kritická',
  'fabric.linking.priority_high': 'Vysoká',
  'fabric.linking.priority_highest': 'Najvyššia',
  'fabric.linking.priority_low': 'Nízka',
  'fabric.linking.priority_lowest': 'Najnižšia',
  'fabric.linking.priority_major': 'Závažná',
  'fabric.linking.priority_medium': 'Stredná',
  'fabric.linking.priority_minor': 'Menej závažná',
  'fabric.linking.priority_trivial': 'Nepodstatná',
  'fabric.linking.priority_undefined': 'Nedefinované',
  'fabric.linking.read_time': '{context} min. čítanie',
  'fabric.linking.related': 'Súvisiace',
  'fabric.linking.related_links_found_in': 'Našlo sa v:',
  'fabric.linking.related_links_includes_links_to': 'Zahŕňa prepojenia na:',
  'fabric.linking.related_links_modal_error_header': 'Niečo sa nepodarilo',
  'fabric.linking.related_links_modal_error_message':
    'Pri načítavaní naposledy použitých prepojení sa vyskytol problém. Skontrolujte pripojenie alebo obnovte stránku a skúste to znova.',
  'fabric.linking.related_links_modal_title': 'Naposledy použité prepojenia',
  'fabric.linking.related_links_modal_unavailable_header': 'Žiadne naposledy použité prepojenia',
  'fabric.linking.related_links_modal_unavailable_message':
    'Nenašli sa žiadne prepojenia, ktoré by tu bolo možné zobraziť. Priebežne prepojenia kontrolujeme a pridávame najnovšie prepojenia na aktualizované stránky alebo iné typy obsahu.',
  'fabric.linking.related_links_not_found': 'Nenašli sa žiadne prepojenia, ktoré by tu bolo možné zobraziť.',
  'fabric.linking.related_links_view_related_urls': 'Zobraziť naposledy použité prepojenia',
  'fabric.linking.request_access': 'Požiadať o prístup',
  'fabric.linking.request_access_description':
    'Váš tím spolupracuje pomocou aplikácie {product}. Odošlite správcovi žiadosť o prístup.',
  'fabric.linking.request_access_pending': 'Čaká na schválenie',
  'fabric.linking.request_access_pending_description':
    'Vaša žiadosť o prístup na lokalitu {hostname} čaká na schválenie správcom.',
  'fabric.linking.request_access_pending_title': 'Žiadosť o prístup k produktu {product} čaká na schválenie.',
  'fabric.linking.request_access_to_view':
    'Ak chcete zobraziť tento problém, požiadajte o udelenie prístupu k aplikácii {context}',
  'fabric.linking.request_access_to_view-issue-term-refresh':
    'Ak chcete zobraziť túto pracovnú položku, požiadajte o prístup k aplikácii {context}.',
  'fabric.linking.request_denied': 'Vaša požiadavka na udelenie prístupu bola zamietnutá',
  'fabric.linking.request_denied_description':
    'Správca neschválil vašu žiadosť o zobrazenie stránok {product} z lokality {hostname}.',
  'fabric.linking.restricted_link': 'Obmedzené prepojenie, skúste iné konto',
  'fabric.linking.retry': 'Skúsiť znova',
  'fabric.linking.save': 'Uložiť',
  'fabric.linking.sent_on_absolute': 'Poslané {context}',
  'fabric.linking.sent_on_relative': 'Odoslané {context}',
  'fabric.linking.srclink': 'Zobraziť v službe:',
  'fabric.linking.srclinkunknown': 'Zobraziť originál',
  'fabric.linking.status_change_load_error': 'Nepodarilo sa načítať stavy a prechody.',
  'fabric.linking.status_change_permission_error': 'Nemáte povolenie na vykonanie prechodu tohto problému.',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'Nemáte povolenie na vykonanie prechodu tejto pracovnej položky.',
  'fabric.linking.status_change_update_error': 'Nepodarilo sa aktualizovať stav.',
  'fabric.linking.try_again': 'Skúsiť znova',
  'fabric.linking.try_another_account': 'Vyskúšať iné konto',
  'fabric.linking.unassigned': 'Nepridelené',
  'fabric.linking.unauthorised_account_description':
    'Pokúšate sa zobraziť ukážku prepojenia na súkromnú stránku {context}. Odporúčame preskúmať adresu URL alebo kontaktovať vlastníka stránky.',
  'fabric.linking.unauthorised_account_description_no_provider':
    'Pokúšate sa zobraziť ukážku prepojenia na súkromnú stránku. Odporúčame preskúmať adresu URL alebo kontaktovať vlastníka stránky.',
  'fabric.linking.unauthorised_account_name': 'Nie je možné zobraziť súkromné stránky z lokality {context}.',
  'fabric.linking.unauthorised_account_name_no_provider': 'Nie je možné zobraziť súkromné stránky.',
  'fabric.linking.unfollow': 'Nesledovať',
  'fabric.linking.unfollow_goal': 'Zrušiť sledovanie cieľa',
  'fabric.linking.unfollow_goal_description':
    'Ak chcete prestať dostávať upozornenia týkajúce sa tohto cieľa, zrušte sledovanie.',
  'fabric.linking.unfollow_goal_error':
    'Vyskytla sa chyba pri pokuse zrušiť sledovanie cieľa. Skontrolujte pripojenie alebo obnovte stránku a skúste to znova.',
  'fabric.linking.unfollow_project': 'Zrušiť sledovanie projektu',
  'fabric.linking.unfollow_project_description':
    'Zrušiť sledovanie a ukončiť zasielanie upozornení týkajúcich sa projektu',
  'fabric.linking.unfollow_project_error':
    'Vyskytla sa chyba pri pokuse zrušiť sledovanie projektu. Skontrolujte pripojenie alebo obnovte stránku a skúste to znova.',
  'fabric.linking.unlink_account': 'Zrušiť prepojenie s kontom',
  'fabric.linking.updated_by': 'Upravil(a): {context}',
  'fabric.linking.view': 'Zobraziť',
};
